import { Button } from '@nick-mazuk/ui/elements/button'
import { Download } from '@nick-mazuk/ui/elements/icon'
import { Image } from '@nick-mazuk/ui/elements/image'
import { Link } from '@nick-mazuk/ui/elements/link'
import { TextContent } from '@nick-mazuk/ui/elements/text-content'
import { YouTube } from '@nick-mazuk/ui/elements/video'
import { HeroSimple } from '@nick-mazuk/ui/marketing/layouts/heros/simple'
import { Laptop } from 'components/laptop'
import { Layout } from 'components/layout'

export default function ChristmasTree(): JSX.Element {
    return (
        <Layout title='Christmas Tree'>
            <section
                className='wrapper'
                style={{ '--c-link': 'var(--c-error-default' } as React.CSSProperties}
            >
                <HeroSimple
                    title={[
                        { text: 'Sparkling', color: '' },
                        { text: 'Christmas', color: 'text-error' },
                        { text: 'Tree', color: 'text-success' },
                    ]}
                    subtitle='As see on OF NOTE, Scoring Notes, and Finale Superuser'
                />
                <div className='max-w-md mx-auto mt-8 mb-16'>
                    <Image
                        src='/images/resources/christmas-tree.gif'
                        alt='Christmas tree animated'
                        eager
                        width={1020}
                        height={1250}
                    />
                </div>
                <TextContent responsive>
                    <p>Happy Holidays!</p>
                    <p>
                        Thanks for checking out how to make a Christmas tree in Finale. Here are all
                        the files you need to get started yourself. These include:
                    </p>
                    <ul>
                        <li>Finale source file</li>
                        <li>JW Lua swapping staves script</li>
                        <li>Keyboard Maestro macro to run the swap staves script</li>
                        <li>Keyboard Maestro macro to add the ossias</li>
                    </ul>
                </TextContent>
                <div className='my-8 text-center'>
                    <Button
                        value='Download files'
                        href='/downloads/christmas-tree/christmas-tree.zip'
                        color='error'
                        icon={<Download />}
                        download
                    />
                </div>
                <TextContent responsive>
                    <p>
                        Also, make sure to check out the accompanying blog posts on{' '}
                        <Link href='http://www.rpmseattle.com/of_note/creating-a-sparkling-christmas-tree-in-finale-from-scratch'>
                            OF NOTE
                        </Link>{' '}
                        and{' '}
                        <Link href='https://www.scoringnotes.com/tips/create-a-sparkling-christmas-tree-in-finale/'>
                            Scoring Notes
                        </Link>
                        .
                    </p>
                    <p>
                        Thanks, <br />
                        Nick Mazuk
                    </p>
                </TextContent>
                <div className='h-8' />
                <Laptop>
                    <YouTube id='3G2M8DepEBE' title='Sparking christmas tree time-lapse' noRatio />
                </Laptop>
            </section>
        </Layout>
    )
}
